import {FC} from 'react';
import {hasValue} from '@kcast-fe/core';
import {ShowMore} from 'ui-kit';

import {EmptyValue} from '../EmptyValue';

interface IProps {
  value: string;
}

export const PartValue: FC<IProps> = ({value}) => {
  if (!hasValue(value) || !hasValue(value.trim())) {
    return <EmptyValue />;
  }

  return <ShowMore text={value} lines={3} />;
};
